import ServerDirections from '@/config/server-directions'
import { Facility } from '@/entities/Facility'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

export class FacilitiesRequests {
  list () {
    const route = ServerDirections.FACILITIES
    const method = 'get'
    function map (data) {
      return data.map(item => new Facility(item))
    }
    return requestService.makePromise(route, method, {}, map)
  }

  get (id) {
    const route = ServerDirections.FACILITIES_ID.replace('{id}', id)
    const method = 'get'
    function map (data) {
      return new Facility(data)
    }
    return requestService.makePromise(route, method, {}, map)
  }
}
